import { graphql } from 'gatsby';

import PreferencesContainer from '../containers/PreferencesContainer';

export default PreferencesContainer;

export const pageQuery = graphql`
  query PageQueryPreferences {
    site: site {
      siteMetadata {
        languages {
          langs
        }
      }
    }
  }
`;
